// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"ActiveAgencyForm_formGroup__wIydK","saveButton":"ActiveAgencyForm_saveButton__3UfR7","label":"ActiveAgencyForm_label__1qtMJ"};